



























// Vuex
import {
    mapGetters,
} from 'vuex';

import {
    detectAndroid,
    detectIOS,
    detectMobile,
} from '@shared/utils/general';
import {
    EventNames,
} from '@shared/utils/analytics-keys';

export default {
    props: {
        size: {
            type: String,
            default: 'small',
            validator(input) {
                return ['small', 'medium', 'large'].includes(input);
            },
        },
        src: {
            type: String,
            default: '',
        },
    },
    computed: {
        ...mapGetters([
            'isPartnerApp',
            'partnerAppData',
            'userId',
        ]),

        detectMobileDevice(): boolean {
            return detectMobile();
        },

        detectAndroidDevice(): boolean {
            return detectAndroid();
        },

        detectIOSDevice(): boolean {
            return detectIOS();
        },
    },
    methods: {
        triggerAnalytics(store) {
            if (this.isPartnerApp) {
                const eventName = (store === 'ios') ? EventNames.PartnerDownloadIos : EventNames.PartnerDownloadAndroid;

                this.$webTrackingInstance?.sendEvent(eventName, [
                    {
                        key: 'partner',
                        value: this.partnerAppData.id,
                    },
                    {
                        key: 'user',
                        value: this.userId,
                    },
                    {
                        key: 'from',
                        value: this.src,
                    },
                ]);
            }
        },
    },
};
